import { insuranceSummary } from './insurance';

// `gi: true` entries are also shown on /gi-pathology (visible only there; the
// FAQPage markup stays on the homepage, since Google wants one marked-up copy).
const faqData = [
  {
    question: "Do you provide GI pathology for GI practices and endoscopy centers in Florida?",
    answer: "Yes. Gastrointestinal pathology is our specialty. We accept GI biopsies and specimens from GI practices, endoscopy and surgery centers, and hospitals throughout Florida, with regional courier pickup. Routine cases typically have results within 24-48 hours, and our pathologists are available to discuss cases directly.",
    link: { to: "/gi-pathology", label: "See GI pathology" },
    gi: true
  },
  {
    // Written to be quotable as a standalone answer (AI answer engines lift
    // single Q&As), so it names the lab and location rather than saying "we".
    question: "Who reads GI biopsies for endoscopy centers in Palm Beach County?",
    answer: "Boca-Delray Pathology Laboratories, an anatomic pathology lab in Delray Beach, reads GI biopsies for endoscopy and ambulatory surgery centers, GI practices, and hospitals in Palm Beach County and across South Florida. GI pathology is the lab's specialty: its board-certified pathologists read biopsies from the esophagus through the colon, routine results are typically ready in 24-48 hours, and the reading pathologist is available directly for questions. New centers get courier pickup and provider portal access.",
    link: { to: "/gi-pathology", label: "See GI pathology for endoscopy centers" },
    gi: true
  },
  {
    question: "What GI pathology conditions do you evaluate?",
    answer: "Our pathologists evaluate endoscopic biopsies and resections from the esophagus, stomach, small bowel, and colon, including Barrett's esophagus and dysplasia, H. pylori gastritis, celiac disease, colorectal polyps, and inflammatory bowel disease such as Crohn's disease and ulcerative colitis.",
    link: { to: "/gi-pathology", label: "See GI pathology" },
    gi: true
  },
  {
    question: "What is anatomic pathology?",
    answer: "Anatomic pathology is a medical specialty that focuses on the diagnosis of disease based on the macroscopic, microscopic, biochemical, and immunologic examination of organs and tissues. Our pathologists examine tissue samples to provide accurate diagnoses that guide treatment decisions."
  },
  {
    question: "How long does it take to get pathology results?",
    answer: "Turnaround times vary depending on the complexity of the case and the type of testing required. Routine cases typically have results within 24-48 hours, while more complex cases involving special stains may take 3-5 business days. We prioritize urgent cases and communicate any delays promptly.",
    link: { to: "/referring-practices", label: "See turnaround times for referring practices" },
    gi: true
  },
  {
    question: "Do you accept specimens from outside facilities?",
    answer: "Yes, we accept specimens from hospitals, clinics, and other healthcare facilities throughout Florida and beyond. We have established protocols for specimen transport and handling to ensure sample integrity and timely processing.",
    link: { to: "/referring-practices", label: "See specimen logistics" }
  },
  {
    question: "Which insurance plans do you accept?",
    answer: `We accept ${insuranceSummary}. Participation can vary by plan and product, so call (561) 638-7577 to confirm a specific plan.`,
    link: { to: "/referring-practices", label: "See accepted insurance" }
  },
  {
    question: "What is immunohistochemistry and when is it used?",
    answer: "Immunohistochemistry is a laboratory technique that uses antibodies to detect specific proteins in tissue samples. It's used to identify cell types, determine the origin of cancer cells, assess treatment response, and provide prognostic information. This technique enhances diagnostic accuracy.",
    link: { to: "/services#immunohistochemistry", label: "See immunohistochemistry services" }
  },
  {
    question: "Do you provide second opinions on pathology cases?",
    answer: "Yes, we offer expert consultation and second opinion services for complex or challenging cases. Our experienced pathologists can review slides and provide additional insights to support optimal patient care. Contact us to discuss your specific needs.",
    link: { to: "/services#consultation", label: "See expert consultation" }
  },
  {
    question: "How do I access the provider portal?",
    answer: "Healthcare providers can access our secure portal at bdp.labdynamo.com to view results, request reports, and manage their account. If you need access credentials or have technical questions, please contact our support team."
  },
  {
    question: "What quality assurance measures do you have in place?",
    answer: "Our laboratory is CLIA-certified (CLIA #10D1012714) and holds The Joint Commission's Gold Seal of Approval, and we follow strict quality control protocols. We participate in proficiency testing programs, maintain comprehensive documentation, and undergo regular inspections to ensure the highest standards of accuracy and reliability."
  }
];

export default faqData;
